import * as React from "react";
import * as ReactDOM from "react-dom";

export interface OverlayProps {
  className?: string;
  innerClassName?: string;
  onClick?: (event: React.SyntheticEvent<any>) => void;
  children: React.ReactChild;
}

class Overlay extends React.Component<OverlayProps> {
  private overlayRoot: HTMLDivElement;

  public constructor(props: OverlayProps) {
    super(props);

    this.overlayRoot = document.createElement("div");
  }

  public componentDidMount() {
    document.body.appendChild(this.overlayRoot);
  }

  public componentWillUnmount() {
    document.body.removeChild(this.overlayRoot);
  }

  private handleClick = event =>
    this.props.onClick ? this.props.onClick(event) : null;

  private handleInnerClick = (event: React.SyntheticEvent<any>) =>
    event.stopPropagation();

  public render() {
    const { className, innerClassName, children } = this.props;

    return (ReactDOM as any).createPortal(
      <div className={className} onClick={this.handleClick}>
        <div className={innerClassName} onClick={this.handleInnerClick}>
          {children}
        </div>
      </div>,
      this.overlayRoot,
    );
  }
}

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/Overlay.tsx